import logger from '@/services/logger';

export async function fetchHTML(url: string): Promise<string> {
  try {
    const response = await fetch(url);
    if (response.ok) {
      return await response.text();
    } else {
      throw new Error(`${response.statusText} ${response.status}`);
    }
  } catch (error) {
    logger.error('Error occurred while retrieving imprint.html', error);
    return '';
  }
}
